import RunIf from './run-if';
import PollywogClassBrowseView from './browse-classes';

export function init() {
	var browseViewElement = document.querySelector('.pw-class-browse-view');
	PollywogClassBrowseView.create(browseViewElement);
}

export function onLoad() {
	RunIf.isPage('page-template-classes-and-workshops', init);
}



// WEBPACK FOOTER //
// ./assets/scripts/classes-and-workshops.js